import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (!environment.production) {
  console.info('[Startup] Bootstrapping Angular application');
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (!environment.production) {
      console.info('[Startup] Angular bootstrap complete');
    }
  })
  .catch((error: unknown) => {
    console.error('[Startup] Angular bootstrap failed', error);
  });
